<template>
  <div>
    <!--<HelloWorld msg="Welcome to Your Vue.js App"/>-->
    <Hero class=""/>

    <personne/>
    <Skills/>

  </div>
</template>

<script>
  // @ is an alias to /src
  import Hero from '@/components/Hero.vue'
  import Personne from '@/components/Personne.vue'
  import Skills from "@/components/Skills";

  export default {
    name: 'Home',
    components: {
      Hero,
      Personne,
      Skills


    }
  }
</script>
